export default "__VITE_ASSET__kzeq53RQ__"